export default {
  loadingMargin: false,
  loadingMarginSave: false,
  margin: {
    marginType: 'ABSOLUTE',
    marginFixedValue: null,
    marginPercentageValue: null,
    marginMixedFixedValue: null,
    marginMixedPercentageValue: null,
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/configuration-invoice/store/states.js